import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CommonService } from '../../../vass-core/services/common.service';

import { environment } from '../../../../environments/environment';
import { AppraisalSectionModel } from '../../models/appraisal-section.model';
import { DocumentationSectionModel } from '../../models/documentation-section.model';
import { SignatureSectionModel } from '../../models/signature-section.model';
import { YourMortgageSectionModel } from '../../models/your-mortgage-section.model';
import { YourRequestSectionModel } from '../../models/your-request-section.model';

@Injectable()
export class DashboardSectionService {
  private updateMortgageSectionData: BehaviorSubject<boolean> = new BehaviorSubject(
    false,
  );
  private yourRequestSectionData: BehaviorSubject<YourRequestSectionModel> =
    new BehaviorSubject(undefined);

  constructor(private commonService: CommonService) {}

  public getYourRequestSectionData(): Observable<YourRequestSectionModel> {
    const url = `${environment.apiBase}/mortgages-dashboard/${environment.api_version.dashboard}/state/request`;
    return this.commonService.getVerb(url).pipe(
      map((response: YourRequestSectionModel) => {
        this.yourRequestSectionData.next(response);
        return response;
      }),
    );
  }

  public getYourRequestSectionCacheData() {
    return this.yourRequestSectionData;
  }

  public getDocumentationSectionData(): Observable<DocumentationSectionModel> {
    const url = `${environment.apiBase}/mortgages-dashboard/${environment.api_version.dashboard}/state/document`;
    return this.commonService.getVerb(url, false);
  }

  public getAppraisalSectionData(): Observable<AppraisalSectionModel> {
    const url = `${environment.apiBase}/mortgages-dashboard/${environment.api_version.dashboard}/state/appraisal`;
    return this.commonService.getVerb(url);
  }

  public getSignatureSectionData(): Observable<SignatureSectionModel> {
    const url = `${environment.apiBase}/mortgages-dashboard/${environment.api_version.dashboard}/state/signature`;
    return this.commonService.getVerb(url);
  }

  public getYourMortgageSectionData(): Observable<YourMortgageSectionModel> {
    const url = `${environment.apiBase}/mortgages-dashboard/${environment.api_version.dashboard}/state/mortgage`;
    return this.commonService.getVerb(url);
  }

  public getUpdateMortgageSectionData() {
    return this.updateMortgageSectionData;
  }

  public setUpdateMortgageSectionData(value) {
    this.updateMortgageSectionData.next(value);
  }
}
